
export class SettingsParcels {
    constructor(
        public id: number = null,
        public emailSender: string = '',
        public emailSenderName: string = '',
        public checked: boolean = false,
        public corporationNumberBd: number = null,
        public corporationNumberName: string = '',
        public useBarcodeScannerStatus: boolean = false,
        public useSignaturePadStatus: boolean = false,
        public showReferenceSignatureStatus: boolean = false,
        public showResidentPhotoStatus: boolean = false,
        public isSendSmsOnlyIfEmailIsEmpty: boolean = false,
        public parcelTypes: Array<any> = [],
        public parcelPostServices: Array<any> = [],
        public parcelStorageLocations: Array<any> = [],
        public staffNotificationSettings: Array<any> = [],
        public residentsNotificationSettings: Array<any> = [],
        public residentsSmsNotificationSettings: Array<any> = [],
        public manualReminder: any = null,
        public dateFormat: string = '',
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public formFields = {
            emailSenderName: {editMode: false}
        }
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/SettingsParcels.ts